const Page404 =()=>{
    return (
        <h5>Page not found...</h5>
    )
}

export default Page404;